// This script to manage data flow from Paperform form submissions to GTM.
window.addEventListener("message", (event) => {
  if (typeof event.data != "string" ||
    !event.data.startsWith("paperform:")
  )
    return;

  try {
    decodedData = JSON.parse(event.data.substring(10));
  } catch (e) {
    return;
  }

  if (
    !decodedData.hasOwnProperty("action") ||
    decodedData.action != "submission"
  )
    return;

  window.dataLayer.push({
    event: "request_form_submitted",
    formLocation: window.location.pathname,
  });
});

function _addMeToCart(e, el) {
  e = e || window.event;
  e.preventDefault();

  let formData = {
      'items': [{
          'id': el.dataset.variant_id,
          'quantity': 1
      }]
  };

  fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
      })
      .then((resp) => {
          return resp.json();
      })
      .then((data) => {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
              bubbles: true
          }));
      })
      .catch((err) => {
          console.error('Error: ' + err);
      })
}
